import { Link } from "react-router-dom";

// Variants: "full" = shield+wordmark stacked image (as designed)
//           "mark" = shield-only crop via CSS object-position
export default function Logo({ variant = "full", className = "", logoClass = "h-12 md:h-14", testId = "site-logo" }) {
  if (variant === "mark") {
    return (
      <Link to="/" data-testid={testId} className={`inline-block ${className}`}>
        <div
          className="relative"
          style={{
            width: 36,
            height: 44,
            backgroundImage: "url(/hoflich-logo.png)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "auto 130px",
            backgroundPosition: "center -10px",
          }}
          aria-label="Hoflich"
        />
      </Link>
    );
  }

  // Full logo as image
  return (
    <Link
      to="/"
      data-testid={testId}
      className={`inline-flex items-center ${className}`}
      aria-label="Hoflich · Building Solutions"
    >
      <img
        src="/hoflich-logo.png"
        alt="Hoflich"
        className={`${logoClass} w-auto select-none transition-all duration-300`}
        draggable={false}
      />
    </Link>
  );
}
